/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
    Tooltip,
    Tabs,
    Tab,
    TextField,         
    InputAdornment,     
    FormControl,       
    InputLabel,         
    Select,           
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    NavigateNext,
    NavigateBefore,
    MoreVert as MoreVertIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    List as ListIcon,
    Add as AddIcon,
    Search as SearchIcon,    
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useDepartment } from 'hooks/api/terminology/department/useDepartment';
import Swal from 'sweetalert2';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { DepartmentForm } from './add';
import { logger } from 'utils/environment/log';
import {
    AuditCell,
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

// Toast Configuration
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
});

// Action Menu Component
const ActionMenu = ({ department, onEdit, onDelete, onToggleActive }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        handleClose();
        action();
    };
    

    return (
        <>
            <Tooltip title="Actions">
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={() => handleAction(onEdit)}>
                    <EditIcon sx={{ mr: 1 }} /> Edit
                </MenuItem>
                <MenuItem onClick={() => handleAction(onToggleActive)} sx={{ color: department.isActive ? 'error.main' : 'success.main' }}>
                    <BlockIcon sx={{ mr: 1 }} /> {department.isActive ? 'Deactivate' : 'Activate'}
                </MenuItem>
            </Menu>
        </>
    );
};

// Search Component - NEW ADDITION
const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'projectName', label: 'Department Name' },
        { value: 'groupCode', label: 'Code' },
        { value: 'groupCodeDescription', label: 'Description' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'updatedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select
                    value={searchField}
                    label="Search Field"
                    onChange={(e) => setSearchField(e.target.value)}
                    disabled={loading}
                >
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>
            
            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find(f => f.value === searchField)?.label || 'Department Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

// Main Department Component
const Department = () => {
    const { listDepartment, departments, createDepartment, deleteDepartment, updateDepartment, getDepartmentById } = useDepartment();
    const [page, setPage] = useState(0);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('projectName');
    const rowsPerPage = 5;

    useEffect(() => {
        fetchDepartments();
    }, []);

    const getFilteredDepartments = () => {
        if (!searchTerm.trim()) {
            return departments;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return departments.filter((department) => {
            const fieldValue = department[searchField];
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };
    const filteredDepartments = getFilteredDepartments();

    const fetchDepartments = async () => {
        setLoading(true);
        try {
            await listDepartment(0, 1000);
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch departments'
            });
        } finally {
            setLoading(false);
        }
    };
    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };


    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            if (values.id && values.id !== 0) {
               
                const updateData = {
                    id: values.id,
                    projectName: values.projectName,
                    groupCode: values.groupCode,
                    groupCodeDescription: values.groupCodeDescription,
                    isActive: values.isActive,
                    isDeleted: values.isDeleted,
                    createdBy: values.createdBy,
                    updatedBy: values.updatedBy,
                    createdAt: values.createdAt,
                    updatedAt: new Date().toISOString()
                };
                await updateDepartment(values.id, updateData);
            } else {
                // Create new department
                const createData = {
                    projectName: values.projectName,
                    groupCode: values.groupCode,
                    groupCodeDescription: values.groupCodeDescription,
                    isActive: values.isActive,
                    isDeleted: false,
                    createdBy: values.createdBy,
                    updatedBy: values.updatedBy,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                };
                await createDepartment(createData);
            }

            await fetchDepartments();
            resetForm();
            setSelectedDepartment(null);
            setActiveTab(0);

            Toast.fire({
                icon: 'success',
                title: `Department ${values.id ? 'updated' : 'added'} successfully`
            });
        } catch (error) {
            logger.error('Error in handleSubmit:', error);
            Toast.fire({
                icon: 'error',
                title: `Failed to ${values.id ? 'update' : 'add'} department`
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleEditClick = async (department) => {
        try {
            let departmentToEdit = department;
            setSelectedDepartment(departmentToEdit);
            setActiveTab(1); // Switch to form tab
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch department details'
            });
        }
    };

    const handleDeleteClick = async (department) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete "${department.projectName}"? You won't be able to revert this!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                await deleteDepartment(department.id);
                await fetchDepartments();
                Toast.fire({
                    icon: 'success',
                    title: 'Department deleted successfully'
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: 'Failed to delete department'
                });
            }
        }
    };

    const handleToggleActive = async (department) => {
        const action = department.isActive ? 'deactivate' : 'activate';
        const result = await Swal.fire({
            title: `Are you sure?`,
            text: `Do you want to ${action} this department?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: department.isActive ? '#d33' : '#28a745',
            cancelButtonColor: '#3085d6',
            confirmButtonText: `Yes, ${action} it!`
        });

        if (result.isConfirmed) {
            try {
                await updateDepartment(department.id, {
                    ...department,
                    isActive: !department.isActive
                });
                await fetchDepartments();
                Toast.fire({
                    icon: 'success',
                    title: `Department ${action}d successfully`
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: `Failed to ${action} department`
                });
            }
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setSelectedDepartment(null);
        }
    };

    const renderDepartmentForm = () => (
        <Fade in timeout={1000}>
            <Box>
                <DepartmentForm
                    initialData={selectedDepartment}
                    onSubmit={handleSubmit}
                    onClear={() => {
                        setSelectedDepartment(null);
                        setActiveTab(0);
                    }}
                />
            </Box>
        </Fade>
    );

    const renderDepartmentList = () => (
        <Box sx={{ mt: 4 }}>

<SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />
 <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredDepartments.length} of {departments.length} departments 
                            {filteredDepartments.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {departments.length} departments</>
                    )}
                </Typography>
            </Box>
           {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <Fade in timeout={1500}>
                    <StyledTableContainer component={Paper}>
                        <Table size="small" sx={tableSx(920)}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ width: 108 }}>Code</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell sx={{ width: 220 }}>Description</TableCell>
                                    <TableCell sx={{ width: 126 }}>Created</TableCell>
                                    <TableCell sx={{ width: 126 }}>Updated</TableCell>
                                    <TableCell sx={{ width: 92 }}>Status</TableCell>
                                    <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {filteredDepartments.length > 0 ? (
                                    filteredDepartments.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((department) => (
                                        <TableRow key={department.id}>
                                            <TableCell><CodeText>{department.groupCode}</CodeText></TableCell>
                                            <TableCell><ClampedText>{department.projectName}</ClampedText></TableCell>
                                            <TableCell><ClampedText>{department.groupCodeDescription}</ClampedText></TableCell>
                                            <TableCell><AuditCell by={department.createdBy} at={department.createdAt} /></TableCell>
                                            <TableCell><AuditCell by={department.updatedBy} at={department.updatedAt} /></TableCell>
                                            <TableCell>
                                                <ConfigurationStatusChip active={department.isActive} />
                                            </TableCell>
                                            <TableCell align="center" sx={stickyActionCellSx}>
                                                <ConfigurationActionMenu
                                                    label={department.projectName}
                                                    actions={[
                                                        { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(department) },
                                                        {
                                                            label: department.isActive ? 'Deactivate' : 'Activate',
                                                            icon: BlockIcon,
                                                            color: department.isActive ? '#b54708' : '#25643b',
                                                            onClick: () => handleToggleActive(department)
                                                        }
                                                    ]}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            {}
                                            <Box sx={{ py: 4 }}>
                                                <Typography variant="body1" color="text.secondary">
                                                    {searchTerm ? (
                                                        <>
                                                            No departments found matching "{searchTerm}" in {searchField}
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography 
                                                                    variant="body2" 
                                                                    color="primary" 
                                                                    sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                    onClick={handleClearSearch}
                                                                >
                                                                    Clear search to view all departments
                                                                </Typography>
                                                            </Box>
                                                        </>
                                                    ) : (
                                                        'No departments available'
                                                    )}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        <ConfigurationPagination
                            page={page}
                            rowsPerPage={rowsPerPage}
                            total={filteredDepartments.length}
                            onPageChange={setPage}
                        />
                    </StyledTableContainer>
                </Fade>
            )}
        </Box>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Departments List" />
                    <Tab icon={<AddIcon />} iconPosition="start" label={selectedDepartment ? 'Edit Department' : 'Add Department'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? renderDepartmentList() : renderDepartmentForm()}
        </Box>
    );
};

export default Department;
